import styled, { css, keyframes } from 'styled-components'

import { ButtonWrapper } from '@/components/Button/Button.styles'
import { Cover } from '@/lib/mixins'

const barCodeAnimation = keyframes`
  0% { top: 0; opacity: 0; }
  10% { top: 0; opacity: 1; }
  50% { opacity: 1; }
  90% { top: 100%; opacity: 1; }
  100% { top: 100%; opacity: 0; }
`

export const ScannerIndicatorIcon = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 5rem;
  margin-bottom: 1.5rem;
  color: var(--color-global);

  &:after {
    position: absolute;
    top: 0;
    height: 2px;
    left: 0;
    right: 0;
    content: ' ';
    background-color: var(--color-primary);
    animation: ${barCodeAnimation} infinite 2s;
  }

  svg {
    display: block;
    width: 80%;
    height: 80%;
    fill: currentColor;
  }
`

export const ScannerIndicatorWrapper = styled.div`
  text-align: center;
  position: relative;
  flex-shrink: 0;

  h5 {
    font-size: 1.4rem;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.global};
  }

  ${props =>
    props.size === 'default' &&
    css`
      padding-bottom: 1.5rem;
    `}

  ${props =>
    props.size === 'small' &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 0 1.5rem 0;

      ${ScannerIndicatorIcon} {
        margin-bottom: 0;
        width: 2.5rem;
        height: 2rem;
        margin-right: 1rem;

        &:after {
          height: 1px;
        }
      }

      h5 {
        font-size: 1rem;
      }
    `};
`

export const ScannerSlider = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin: 2vh 0;
  max-height: 40vh;
  overflow: hidden;
  position: relative;

  .marquee-container {
    overflow: visible;
    .marquee {
      display: flex;
    }
  }
`

export const ScannerSliderImage = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;

  img {
    display: block;
    width: ${props => (props.isPortrait ? '140vw' : '95vw')};
    object-fit: contain;

    @media (min-width: 1024px) {
      width: ${props => (props.isPortrait ? '140vw' : '95vw')};
    }

    @media (min-width: 1280px) {
      width: ${props => (props.isPortrait ? '140vw' : '1280px')};
      height: ${props => (props.isPortrait ? '140vw' : '40vh')};
      object-fit: contain;
    }
  }
`

export const ScannerLogo = styled.div`
  flex-shrink: 0;
  
  svg {
    height: 6rem;
    margin: 0 auto;
    display: block;
  }

  img{
    height: 6rem;
    margin: 0 auto;
    display: block;
  }
`

export const ScannerWrapper = styled.div`
  ${Cover()}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  padding: 4vh 0;
  box-sizing: border-box;

  ${ScannerIndicatorWrapper} {
  }
`

export const ScannerCta = styled.div`
  text-align: center;
  flex-shrink: 0;
  position: relative;
  z-index: 10;

  ${ButtonWrapper} {
    min-width: 26rem;
  }
`

export const ScannerProvider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 0.9rem;
  padding: 1rem 0 2rem 0;
  flex-shrink: 0;
  color: var(--color-muted);

  img {
    height: 2rem;
    margin-top: 0.5rem;
    cursor: pointer;
  }
`

const arrowAnimation = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(0.75rem); }
  100% { transform: translateY(0); }
`
export const ScannerIndicatorArrow = styled.div`
  margin-top: 0.75rem;
  animation: ${arrowAnimation} 2s infinite;

  path {
    fill: none;
  }
`
